// extracted by mini-css-extract-plugin
export default {"container":"PeopleCountRadio_container__mjWXD","title":"PeopleCountRadio_title__G9Xxy","inputs":"PeopleCountRadio_inputs__ApnfJ"};